const DATE_KEY = /^(\d{4})-(\d{2})-(\d{2})/;

export function parseCalendarDate(value: unknown): Date | null {
  const match = String(value || '').match(DATE_KEY);
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) return null;
  return date;
}

export function formatCalendarDate(value: unknown, fallback = '—'): string {
  const date = parseCalendarDate(value);
  return date
    ? date.toLocaleDateString('pt-BR', { timeZone: 'UTC' })
    : fallback;
}

export function daysUntilCalendarDate(value: unknown, reference = new Date()): number | null {
  const target = parseCalendarDate(value);
  if (!target) return null;
  const today = Date.UTC(reference.getFullYear(), reference.getMonth(), reference.getDate());
  return Math.round((target.getTime() - today) / 86_400_000);
}
